import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VToolbar,{staticClass:"mb-1",attrs:{"color":""}},[_c(VToolbarTitle,{staticClass:"ml-1 mr-2",style:({ color: _vm.getOutlineColor }),domProps:{"innerHTML":_vm._s(_vm.title)}}),_c(VSpacer),_vm._t("header")],2),_c(VVirtualScroll,{attrs:{"items":_vm.items,"height":_vm.scrollHeigth,"item-height":_vm.itemHeigth},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c(VList,{attrs:{"two-line":""}},[_c(VListItem,{key:props.index + Math.random()},[_c(VListItemContent,[_vm._t("content")],2)],1),_c(VDivider)],1)]}}],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }